import React from 'react';
import './SectionNavigation.css';

const SectionNavigation = ({
  currentSection,
  totalSections,
  onPrevious,
  onNext,
  onSubmit,
  canSubmit,
  isLoading,
  isReadOnly = false
}) => {
  const isFirstSection = currentSection === 0;
  const isLastSection = currentSection === totalSections - 1;

  return (
    <div className="section-navigation">
      <div className="nav-buttons">
        <div className="nav-left">
          {!isFirstSection && (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onPrevious}
              disabled={isLoading}
            >
              <span className="btn-text-desktop">← Previous</span>
              <span className="btn-text-mobile">Previous</span>
            </button>
          )}
        </div>

        <div className="nav-right">
          {!isLastSection ? (
            <button
              type="button"
              className="btn btn-primary"
              onClick={onNext}
              disabled={isLoading}
            >
              <span className="btn-text-desktop">Next →</span>
              <span className="btn-text-mobile">Next</span>
            </button>
          ) : (
            !isReadOnly && (
              <button
                type="button"
                className={`btn ${canSubmit ? 'btn-success' : 'btn-secondary'}`}
                onClick={onSubmit}
                disabled={!canSubmit || isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner"></span>
                    Submitting...
                  </>
                ) : (
                  'Submit Application'
                )}
              </button>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionNavigation;
